// =============================================================================
// TERMS PAGE COMPONENT
// =============================================================================

import React from 'react';
import { Navbar, Footer } from '@/components/Layout';
import { ContentRenderer } from '@/components/ContentRenderer';
import { SEOHead } from '@/components/SEO';
import { termsPageComponents } from '@/data/legalPageContent';
import { navItems, footerLinks, socialLinks } from '@/data/homeContent';
import { seoData } from '@/data/seoData';

export const TermsPage: React.FC = () => {
  const seo = seoData.terms;
  
  return (
    <div className="terms-page">
      <SEOHead
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        noIndex={seo.noIndex}
      />
      
      <Navbar 
        brand="Alex Finger Consulting"
        navItems={navItems}
        showThemeSwitcher={false}
      />
      
      <main className="main-content">
        <ContentRenderer components={termsPageComponents} />
      </main>
      
      <Footer
        brand="Alex Finger Consulting"
        description="Web development and business strategy services. Transform your ideas into digital reality."
        links={footerLinks}
        socialLinks={socialLinks}
      />
    </div>
  );
};
